import { CommonModule, DatePipe } from '@angular/common'
import { Component, NgZone, OnInit, ViewChild } from '@angular/core'
import {
  FormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router, RouterLinkActive } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroDocumentDuplicate, heroPencil, heroFolder } from '@ng-icons/heroicons/outline'
import {
  KENDO_DIALOGS,
  WindowCloseResult,
  WindowComponent,
  WindowRef,
  WindowService,
} from '@progress/kendo-angular-dialog'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import { CellTemplateDirective, ColumnComponent, DataBindingDirective, GridComponent, KENDO_GRID } from '@progress/kendo-angular-grid'
import { KENDO_ICONS } from '@progress/kendo-angular-icons'
import { State, process } from '@progress/kendo-data-query'
import * as CryptoJS from 'crypto-js'
import { ToastrService } from 'ngx-toastr'
import { take } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { ClientServices } from '../../@theme/services/clients.service'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'

@Component({
  selector: 'gd--advisors',
  templateUrl: './advisors.component.html',
  styleUrls: ['./advisors.component.css'],
  imports: [
    CommonModule,
    KENDO_GRID,
    KENDO_DIALOGS,
    GridComponent,
    DataBindingDirective,
    ColumnComponent,
    CellTemplateDirective,
    RouterLinkActive,
    KENDO_ICONS,
    DatePipe,
    NgIcon,
    FormsModule,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
  ],
  providers: [
    provideIcons({ heroDocumentDuplicate, heroPencil, heroFolder })
  ]
})
export class AdvisorsComponent implements OnInit {
  @ViewChild(GridComponent, { static: true })
  public grid: GridComponent
  public view: any[] = []
  public clientId: string
  public clientName: string
  private decPassword: string
  public repId: string
  public viewallblot: string
  private overlayEl: HTMLElement
  public group: any[] = [
    {
      field: 'lastName',
    },
  ]
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 21,
  }
  public formGroup: UntypedFormGroup
  public opened: boolean
  public windowRef: WindowRef = null
  private startdate = new UntypedFormControl(new Date())
  private enddate = new UntypedFormControl(new Date())
  gridExcelexport: any[] = []
  ngModelDate = new Date()
  ngModelendDate = new Date()
  param1: string
  param2: string
  selectedItem = '1'
  public aggregates: any[] = []
  constructor(
    private route: ActivatedRoute,
    private ur: ClientServices,
    private toastrService: ToastrService,
    private ngZone: NgZone,
    private router: Router,
    private windowService: WindowService,
  ) {
    this.decPassword = environment.encPassword
    if (this.route.snapshot.queryParams['ClientId']) {
      this.route.queryParams.subscribe((params) => {
        const paramT = CryptoJS.AES.decrypt(
          params['ClientId'],
          this.decPassword,
        ).toString(CryptoJS.enc.Utf8)
        this.param1 = paramT
      })
    }
    this.GetDataLoad()
    this.opened = false
    this.allData = this.allData.bind(this)
    this.viewallblot = ''
  }
  ngOnInit(): void {
    this.opened = false
  }
  GetDataLoad(): void {
    this.ur.getAdvisorClientList().subscribe((response) => {
      this.view = response
      if (this.param1 !== undefined) {
        const myobjects = this.view.filter((b) => b.clientId == this.param1)
        this.view = myobjects
        return
      }
      this.view = response
      return
    })
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.view, {
        group: this.group,
        sort: [{ field: 'clientId', dir: 'asc' }],
      }).data,
      group: this.group,
    }
    return result
  }
  private fitColumns(): void {
    this.ngZone.onStable
      .asObservable()
      .pipe(take(1))
      .subscribe(() => {
        this.grid.autoFitColumns()
      })
  }
  public editHandler({ sender, rowIndex, dataItem }) {
    sender.editRow(rowIndex, this.formGroup)
  }
  public onStateChange(state: State) {
    this.gridState = state
    this.ur.read()
  }
  returndata(component) {
    const options = component.workbookOptions()
    const rows = options.sheets[0].rows
    let altIdx = 0
    rows.forEach((row) => {
      if (row.type == 'data') {
        if (altIdx % 2 !== 0) {
          row.cells.forEach((cell) => {
            cell.background = '#aabbcc'
          })
        }
        altIdx++
      }
    })
    component.save(options)
  }
  public removeHandler({ dataItem }) {
    const param = { AlertCcemailId: dataItem.alertCcemailId }
  }
  public addHandler({ sender }) {
    this.formGroup = new UntypedFormGroup({
      alertCcemailId: new UntypedFormControl(),
      role: new UntypedFormControl('', Validators.required),
      ccemail: new UntypedFormControl(''),
    })

    sender.addRow(this.formGroup)
  }
  public saveHandler({ sender, rowIndex, formGroup, isNew }) {
    const alcc: any = formGroup.value
    const alertId = alcc.alertCcemailId ? alcc.alertCcemailId : 0
    const Param = {
      AlertCcemailId: alertId,
      Role: alcc.role,
      Ccemail: alcc.ccemail,
    }
  }
  public cancelHandler({ sender, rowIndex }) {
    // /  this.closeEditor(sender, rowIndex)
  }

  showToastpst(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }

  /* click open FileManager popup */
  viewFiles(
    repid: string,
    clientInfo: string,
    LastName: string,
    FirstName: string,
  ): void {
    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }
    this.clientId = clientInfo
    this.repId = repid
    if (LastName.length > 0) {
      this.clientName = LastName + ', ' + FirstName
    } else {
      this.clientName = FirstName
    }

    // Create overlay element
    this.overlayEl = document.createElement('div')
    this.overlayEl.classList.add('k-overlay')
    document.body.appendChild(this.overlayEl)

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    this.windowRef.result.subscribe(() => this.destroyOverlay())

    const fileManager = this.windowRef.content.instance

    fileManager.viewallblot = this.viewallblot
    fileManager.outputrepId = this.repId
    fileManager.outputClientId = this.clientId
    fileManager.clientName = this.clientName

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }

  private destroyOverlay(): void {
    if (this.overlayEl && document.body.contains(this.overlayEl)) {
      document.body.removeChild(this.overlayEl)
    }
  }

  close(): void {
    this.opened = false
  }
  LoadviewfrmAddaccounts(v: any) {
    return
  }
  EditAccount(clientId: number) {
    this.router.navigate(['/pages/AccountForm/add-account'], {
      queryParams: { Cld: clientId },
    })
  }
  viewTransactionsList(clientId: number, repId: number) {
    const encryptingclient = clientId.toString()
    const encryptingrep = repId.toString()
    const clientParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingclient).trim(),
      environment.securepw.trim(),
    ).toString()
    const repParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingrep).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/Transactions/app-transviewer'], {
      queryParams: { R: clientParam, Rp: repParam },
    })
  }
  viewTransactions(clientId: number, repId: number) {
    const encryptingclient = clientId.toString()
    const encryptingrep = repId.toString()
    const clientParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingclient).trim(),
      environment.securepw.trim(),
    ).toString()
    const repParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingrep).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/Transactions/gd-transviewer'], {
      queryParams: { R: clientParam, Rp: repParam },
    })
  }
}
